import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

/* Pages */
import HomePage          from './pages/HomePage';
import PrivacyPage       from './pages/PrivacyPage';
import ContactPage       from './pages/ContactPage';
import DeleteAccountPage from './pages/DeleteAccountPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/"               element={<HomePage />}          />
        <Route path="/privacy"        element={<PrivacyPage />}       />
        <Route path="/contact"        element={<ContactPage />}       />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
      </Routes>
    </Router>
  );
}

export default App;